export function CommentaryHeader({
  title,
  isExpanded,
  isExpandDisabled,
  onToggle,
}: {
  title: string;
  isExpanded: boolean;
  isExpandDisabled: boolean;
  onToggle: () => void;
}) {
  return (
    <header
      className={`commentary-header ${isExpandDisabled ? "disabled" : ""}`}
      onClick={onToggle}
    >
      <span>{title}</span>
      <button
        className="commentary-expand-events-button"
        disabled={isExpandDisabled}
      >
        <img
          src={
            isExpandDisabled
              ? "/images/box-score/down-arrow-disabled.svg"
              : "/images/box-score/down-arrow.svg"
          }
          alt="toggle"
          className={`commentary-event-arrow ${
            isExpanded ? "commentary-event-up-arrow" : ""
          }`}
        />
      </button>
    </header>
  );
}
